@use "styles" as *;
@use "sass:map";

$block: me-separated-layout;

.#{$block} {
  display: inline-block;
  line-height: 1.3;

  &__content {
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;

    &--center {
      justify-content:  center;
    }
  }

  &__item {
    display: inline-flex;
    flex-direction: row;

    &:last-of-type .#{$block}__separator {
        display: none;
    }
  }

  &__separator {
    color: $color-gray-300;
  }

  @each $size, $size-options in $separated-layout-sizes {
    &--#{$size} {
      font-size: map.get($size-options, font-size);

      .#{$block}__content {
        column-gap: map.get($size-options, column-gap);
      }

      .#{$block}__item {
        column-gap: map.get($size-options, column-gap);
      }
    }
  }
}
